"use strict";

export default class JobTag {
  addTag() {
    let tagName = $('.job_tag_name').val().trim()

    if (this.tryToAdd(tagName)) {
      $('.job_tag_name').val('')
      $('.job_tag_name').focus()
    }
  }

  tryToAdd(tagName) {
    if (tagName != '' && this.isNotTagNameExisted(tagName)) {
      $('.job_tag').last().after(
        `<div class="alert alert-secondary alert-dismissible border-0 mr-2 job_tag">
          <button class="close p-1 pr-2" data-dismiss="alert" type="button">×</button>
          <strong>${tagName}</strong>
          <input name="job_form[job_tags][]" type="hidden" value="${tagName}">
        </div>`
      )
      return true
    } else {
      alert(gon.views.shared.models.job_tag.invalid)
      return false
    }
  }

  addTagFromModal(tagName) {
    if (this.tryToAdd(tagName)) {
      $('.modal').modal('hide')
    }
  }

  isNotTagNameExisted(tagName) {
    var result = true
    $('input[type="hidden"][name="job_form[job_tags][]"]').each((_, element) => {
      if (element.defaultValue.toLowerCase() == tagName.toLowerCase()) {
        result = false
        return false  // exit the loop
      }
    })
    return result
  }
}
